export default "__VITE_PUBLIC_ASSET__a07d2719__"